import {
  GA4_MEASUREMENT_ID,
  GOOGLE_ADS_ID,
  MARKETING_LINKER_DOMAINS,
} from "@/app/_constants/marketing";

const linkerDomains = MARKETING_LINKER_DOMAINS.map((domain) => `'${domain}'`).join(
  ", "
);

// Same IDs and linker.domains as www.mountmonitor.com (landing PR #2). Native
// tags in <head> so Ads config is in the first HTML, not only after hydration.
// Production hosts only — no Vercel preview domains — so _gl / gclid hops
// landing ↔ app.mountmonitor.com both ways.
const linker = `{ domains: [${linkerDomains}] }`;
const bootstrap = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('set', 'linker', ${linker});
  gtag('js', new Date());
  gtag('config', '${GA4_MEASUREMENT_ID}', { linker: ${linker} });
  gtag('config', '${GOOGLE_ADS_ID}', { linker: ${linker} });
`;

export default function GoogleTag() {
  return (
    <>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${GA4_MEASUREMENT_ID}`}
      />
      <script
        id="google-analytics"
        dangerouslySetInnerHTML={{ __html: bootstrap }}
      />
    </>
  );
}
